import { EmailShareButton } from "next-share";
import email_icon from "../assets/email_icon.svg";

export const EmailShareTemplate = ({ pageUrl, pageTitle, body }) => {
  return (
    <EmailShareButton url={pageUrl} subject={pageTitle} body={body}>
      <img src={email_icon} alt="" />
    </EmailShareButton>
  );
};
